// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Campaign48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Campaign48Filled: FC<Campaign48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M36.5 25.5v-3H44v3h-7.5ZM39 40l-6.05-4.5 1.8-2.4 6.05 4.5L39 40Zm-4.1-25.15-1.8-2.4L39 8l1.8 2.4-5.9 4.45ZM10.5 38v-8H7a2.893 2.893 0 0 1-2.125-.875A2.893 2.893 0 0 1 4 27v-6c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 7 18h9l10-6v24l-10-6h-2.5v8h-3ZM28 30.7V17.3c.9.8 1.625 1.775 2.175 2.925.55 1.15.825 2.408.825 3.775s-.275 2.625-.825 3.775A9.134 9.134 0 0 1 28 30.7Z" />
        </svg>
    );
};

export default Campaign48Filled;
